import { render, staticRenderFns } from "./PagesCreateNew.vue?vue&type=template&id=2c331a14&scoped=true&"
import script from "./PagesCreateNew.vue?vue&type=script&lang=js&"
export * from "./PagesCreateNew.vue?vue&type=script&lang=js&"
import style0 from "./PagesCreateNew.vue?vue&type=style&index=0&id=2c331a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c331a14",
  null
  
)

export default component.exports